/* Arka: custom fitted bedsheet option + cart safeguard.
   - On bedsheet pages, "Fitted (custom)" collects mattress size and adds the
     Fitted Bedsheet Conversion add-on together with the (flat) bedsheet.
   - On every page, keeps each add-on line's quantity equal to its linked
     bedsheet, and removes add-ons whose bedsheet is gone. */
(function () {
  if (window.ArkaFitted) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var REF = '_fitted_ref';

  // The choice sits under the price (outside the add-to-cart form), so look for it
  // in the same product block: the product page, a quick-add popup, or the form itself.
  function scopeOf(el) {
    return (el && (el.closest('product-info') || el.closest('quick-add-modal') || el.closest('[id^="shopify-section"]'))) || document;
  }

  function boxFor(form) {
    if (!form) return null;
    return form.querySelector('[data-arka-fitted]') || scopeOf(form).querySelector('[data-arka-fitted]');
  }

  function isFitted(box) {
    var c = box && box.querySelector('input[name="arka_fitted_choice"]:checked');
    return !!(c && c.value === 'fitted');
  }

  function showError(box, msg) {
    var el = box.querySelector('[data-arka-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function toggle(box) {
    var fitted = isFitted(box);
    var fields = box.querySelector('[data-arka-fields]');
    if (fields) fields.hidden = !fitted;
    box.toggleAttribute('data-is-fitted', fitted);
    if (!fitted) showError(box, '');
    // "Buy it now" skips the cart, so it can't carry the add-on: hide it for fitted.
    // Done with an attribute + CSS so it still applies after the buttons re-render on a size change.
    var scope = scopeOf(box);
    if (scope && scope.setAttribute) scope.toggleAttribute('data-arka-fitted-on', fitted);
  }

  function fittedSummary(box) {
    if (!box || !isFitted(box)) return '';
    var parts = [];
    box.querySelectorAll('[data-dim]').forEach(function (i) {
      parts.push(i.value ? i.value : '?');
    });
    return 'Bedsheet type: Fitted (custom), mattress L x W x D: ' + parts.join(' x ') + ' in';
  }

  /* Called by product-form.js before adding to cart.
     Returns the FormData to send, or null to stop (validation failed). */
  function prepare(form, formData) {
    formData.delete('arka_fitted_choice');
    var box = boxFor(form);
    if (!box || !isFitted(box)) return formData;

    var inputs = Array.prototype.slice.call(box.querySelectorAll('[data-dim]'));
    var missing = [];
    var outOfRange = [];
    var dims = {};
    inputs.forEach(function (input) {
      var raw = String(input.value).trim();
      var v = parseFloat(raw.replace(',', '.'));
      var min = parseFloat(input.min);
      var max = parseFloat(input.max);
      var name = input.dataset.label.toLowerCase();
      var ok = !isNaN(v) && v >= min && v <= max;
      input.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (ok) dims[input.dataset.dim] = String(v);
      else if (raw === '' || isNaN(v)) missing.push(name);
      else outOfRange.push(name + ' should be ' + min + '–' + max + ' in');
    });
    function list(a) { return a.length > 1 ? a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1] : a[0]; }
    if (missing.length || outOfRange.length) {
      var msg = [];
      if (missing.length) msg.push('Please enter your mattress ' + list(missing) + '.');
      if (outOfRange.length) msg.push(outOfRange.map(function (s) { return s.charAt(0).toUpperCase() + s.slice(1); }).join('. ') + '.');
      showError(box, msg.join(' '));
      var first = box.querySelector('[aria-invalid="true"]');
      if (first) {
        // the choice is above the button (and the phone sticky bar), so bring it into view
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        first.focus({ preventScroll: true });
      }
      return null;
    }
    showError(box, '');

    var id = formData.get('id');
    var qty = formData.get('quantity') || '1';
    var ref = 'F' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var out = new FormData();

    out.append('items[0][id]', id);
    out.append('items[0][quantity]', qty);
    // keep any other line-item properties the form already had
    formData.forEach(function (value, key) {
      if (key.indexOf('properties[') === 0) {
        out.append('items[0][properties]' + key.slice('properties'.length), value);
      }
    });
    out.append('items[0][properties][Bedsheet type]', 'Fitted (custom)');
    Object.keys(dims).forEach(function (k) {
      out.append('items[0][properties][' + k + ']', dims[k]);
    });
    out.append('items[0][properties][' + REF + ']', ref);

    out.append('items[1][id]', box.dataset.addonVariant);
    out.append('items[1][quantity]', qty);
    out.append('items[1][properties][For]', box.dataset.productTitle);
    out.append('items[1][properties][' + REF + ']', ref);
    return out;
  }

  /* ---------- cart safeguard ---------- */
  var syncing = false;
  function sync() {
    if (syncing) return;
    var addonId = Number(window.ArkaFittedAddonId || 0);
    if (!addonId) return;
    syncing = true;
    fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sheets = {};
        cart.items.forEach(function (it) {
          var ref = it.properties && it.properties[REF];
          if (ref && it.variant_id !== addonId) sheets[ref] = (sheets[ref] || 0) + it.quantity;
        });
        var updates = {};
        var changed = false;
        cart.items.forEach(function (it) {
          if (it.variant_id !== addonId) return;
          var ref = it.properties && it.properties[REF];
          var want = ref ? sheets[ref] || 0 : 0;
          if (it.quantity !== want) { updates[it.key] = want; changed = true; }
        });
        if (!changed) return;
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { window.location.reload(); });
      })
      .catch(function (e) { console.error('[Arka fitted] cart sync', e); })
      .finally(function () { syncing = false; });
  }

  function init() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'arka_fitted_choice') toggle(t.closest('[data-arka-fitted]'));
      if (t && t.matches && t.matches('[data-dim]')) t.removeAttribute('aria-invalid');
    });
    // "Order on WhatsApp": add the fitted choice and mattress size to the pre-filled message.
    // The button's own handler sets the link first; this runs after it (bubble phase).
    document.addEventListener('click', function (e) {
      var wa = e.target && e.target.closest && e.target.closest('.arka-wa__btn');
      if (!wa) return;
      var extra = fittedSummary(scopeOf(wa).querySelector('[data-arka-fitted]'));
      if (!extra) return;
      try {
        var url = new URL(wa.href);
        url.searchParams.set('text', (url.searchParams.get('text') || '') + '\n' + extra);
        wa.href = url.toString();
      } catch (err) {}
    });
    document.querySelectorAll('[data-arka-fitted]').forEach(toggle);
    // quick-add modals inject the form later
    new MutationObserver(function () {
      document.querySelectorAll('[data-arka-fitted]:not([data-arka-ready])').forEach(function (b) {
        b.setAttribute('data-arka-ready', '');
        toggle(b);
      });
    }).observe(document.body, { childList: true, subtree: true });

    sync();
    // PUB_SUB_EVENTS is a top-level const in constants.js, so not on window.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sync, 400); });
    }
  }

  window.ArkaFitted = { prepare: prepare, sync: sync };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
